/* eslint-disable */
import { Component } from 'react';
import ErrorPane from 'components/shared/error-pane/error-pane';

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <ErrorPane />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
